import { render, staticRenderFns } from "./PreferentialBubble.vue?vue&type=template&id=4af1f84c&lang=html"
import script from "./PreferentialBubble.vue?vue&type=script&lang=js"
export * from "./PreferentialBubble.vue?vue&type=script&lang=js"
import style0 from "./PreferentialBubble.vue?vue&type=style&index=0&id=4af1f84c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports